// Sportpacks Redesign - (c) 2026 NextPercent, nextpercent.de
// Lizenziert ausschliesslich fuer sport-packs.myshopify.com.
// Einsatz in weiteren Shops nur mit schriftlicher Genehmigung: info@nextpercent.de
(() => {
  if (window.spServiceReady) return;
  window.spServiceReady = true;
  const states = new WeakMap();
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.sp-help__questions summary');
    if (!summary) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const details = summary.parentElement;
    const previous = states.get(details);
    const expand = previous ? !previous.expand : !details.open;
    const from = details.getBoundingClientRect().height;
    previous?.animation.cancel();
    details.style.height = '';
    details.open = true;
    const border = parseFloat(getComputedStyle(details).borderTopWidth) + parseFloat(getComputedStyle(details).borderBottomWidth);
    const to = expand ? details.getBoundingClientRect().height : summary.getBoundingClientRect().height + border;
    details.dataset.expanding = String(expand);
    const finish = () => {
      details.open = expand;
      details.style.height = '';
      details.style.overflow = '';
      delete details.dataset.expanding;
      states.delete(details);
    };
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      finish();
      return;
    }
    details.style.overflow = 'hidden';
    details.style.boxSizing = 'border-box';
    const animation = details.animate([{ height: `${from}px` }, { height: `${to}px` }], {
      duration: 340,
      easing: 'cubic-bezier(.22, 1, .36, 1)'
    });
    states.set(details, { animation, expand });
    animation.onfinish = finish;
  }, true);
})();
